const lastNotificationStorageClient = window.localStorage;

export default lastNotificationStorageClient;
